import ToggleItem from './ToggleItem';
import { ToggleItemProps, ToggleItemValueProps } from './types';

export type { ToggleItemProps, ToggleItemValueProps };
export default ToggleItem;
